module.exports = __webpack_public_path__ + "static/media/cctv5.f3d32892.png";